import script from "./CriarGoogleForms.vue?vue&type=script&setup=true&lang=js"
export * from "./CriarGoogleForms.vue?vue&type=script&setup=true&lang=js"

import "./CriarGoogleForms.vue?vue&type=style&index=0&id=46897fb7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46897fb7"]])

export default __exports__